import { getApiConfig } from "../../utils/appUtils";
import { OmsenApi } from "../../api";

export default function useOmsenApiClient() {
  const apiConfig = getApiConfig();
  return new OmsenApi(apiConfig);
}
